<template>
  <page-layout
    :show-filter="true"
    :filter-fields="filterFields"
    :show-action-bar="true"
    :action-bar-show-import="true"
    :action-bar-show-export="true"
    @filter-search="handleSearch"
    @filter-reset="handleReset"
    @import="handleImport"
    @export="handleExport"
  >
    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column prop="dataCode" label="数据编码" />
      <el-table-column prop="plateNumber" label="车牌号" />
      <el-table-column prop="driverName" label="司机名称" />
      <el-table-column prop="departureSite" label="发出网点" />
      <el-table-column prop="arrivalSite" label="到达网点" />
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-if="total > 0"
      :current-page="currentPage"
      :page-sizes="[20, 30, 50]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </page-layout>
</template>

<script>
export default {
  name: 'VehicleMonitorData',
  data() {
    return {
      filterFields: [
        {
          id: 'dataCode',
          label: '数据编码',
          component: 'el-input',
          props: {
            placeholder: '请输入数据编码'
          }
        },
        {
          id: 'plateNumber',
          label: '车牌号',
          component: 'el-input',
          props: {
            placeholder: '请输入车牌号'
          }
        },
        {
          id: 'departureSite',
          label: '发出网点',
          component: 'el-select',
          props: {
            placeholder: '请选择'
          }
        },
        {
          id: 'arrivalSite',
          label: '到达网点',
          component: 'el-select',
          props: {
            placeholder: '请选择'
          }
        },
        {
          id: 'importTime',
          label: '导入时间',
          component: 'el-date-picker',
          props: {
            type: 'daterange',
            rangeSeparator: '~',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期'
          }
        }
      ],
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  methods: {
    handleSearch() {
      // 搜索逻辑
      console.log('搜索')
    },
    handleReset() {
      // 重置逻辑
      console.log('重置')
    },
    handleImport() {
      // 导入逻辑
      console.log('导入')
    },
    handleExport() {
      // 导出逻辑
      console.log('导出')
    },
    handleEdit(row) {
      // 编辑逻辑
      console.log('编辑', row)
    },
    handleDelete(row) {
      // 删除逻辑
      console.log('删除', row)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    loadData() {
      // 加载数据逻辑
      console.log('加载数据')
    }
  }
}
</script>



